import Axios from 'axios';

Axios.defaults.withCredentials = true;
const AXIOS_DEFAULT_CONFIG = {
    baseURL: 'localhost:1108',
    timeout: 20000,
    maxContentLength: 2000,
    headers: {},
};

let axios = Axios.create(AXIOS_DEFAULT_CONFIG);

//http request拦截器
axios.interceptors.response.use((response) => {
    let res;
    if (response.method === 'get') {
      //  给data赋值以绕过if判断
      response.data = true;
    }
    if (!response.headers) {
      response.headers = {};
    }
    response.headers['Content-Type'] = 'application/json';
    if (response.status === 200) res = response.data;
    return res;
});
export default axios;